//@ts-nocheck
import * as type from "../actions/actionTypes";

const initialState = {
  configuration: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.GET_SENTRY_CONFIGURATION_RECEIVE:
      return {
        ...state,
        configuration: action.payload,
      };
    default:
      return state;
  }
};
